export function modal() {
    document.addEventListener('DOMContentLoaded', function () {
        const tabLists = document.querySelector('.p-top-pickup__tab-lists');

        function closeModal() {
            const modals = document.querySelectorAll('.js-modal');
            modals.forEach(modal => {
                modal.classList.remove('is-active');
            });
            document.body.classList.remove('body-no-scroll');
            if (tabLists) {
                tabLists.classList.remove('z-index-reduced');
            }
        }

        const modalOpenButtons = document.querySelectorAll('.js-modal-open');
        const modalCloseButtons = document.querySelectorAll('.js-modal-close');

        modalOpenButtons.forEach(button => {
            button.addEventListener('click', function () {
                const modalId = button.getAttribute('data-modal');
                const modal = document.getElementById(modalId);
                if (modal) {
                    modal.classList.add('is-active');
                    document.body.classList.add('body-no-scroll');
                    if (tabLists) {
                        tabLists.classList.add('z-index-reduced');
                    }
                }
            });
        });

        modalCloseButtons.forEach(button => {
            button.addEventListener('click', function () {
                closeModal();
            });
        });

        // モーダル背景クリックで閉じる処理
        document.querySelectorAll('.js-modal').forEach(modal => {
            modal.addEventListener('click', function (event) {
                if (event.target === modal) {
                    closeModal();
                }
            });
        });
    });
}
